module.exports = __webpack_public_path__ + "img/solution--easy-patient-transportation.77e63a22.png";